import React from 'react';
import classnames from 'classnames';
import { withStyles } from '@material-ui/styles';
import { CircularProgress } from '@material-ui/core';
import jmiReportsImage from '../../assets/images/jmi-logo.png';
import imageNotAvailable from '../../assets/images/image-not-available.png';
import SelfInspectBackButton from '../../pages/self-inspect/SelfInspectBackButton';
import SelfInspectButton from './SelfInspectButton';

const styles = theme => ({
  container: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'auto',
  },

  topHalf: {
    // flex: 1,
    minHeight: 150,
    overflow: 'auto',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    //background: 'red',
  },
  bottomHalf: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },

  supportNumber: {
    //marginTop: 20,
    flexGrow: 0,
    flexBasis: 'auto',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-end',
    //background: 'green',
  },

  actionContainer: {
    //marginTop: 20,
    flexGrow: 0,
    flexBasis: 'auto',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    //background: 'orange',
    paddingTop: 5,
    paddingBottom: 5,
  },
  image: {
    maxHeight: '100%',
    maxWidth: '80%',
    borderRadius: '5px',
  },

  reporterName: {
    fontSize: '2rem',
    textAlign: 'center',
    // fontWeight: 'bold',
  },

  questionLabel: {
    fontSize: '1rem',
    textAlign: 'center',
  },

  questionValue: {
    fontSize: '1.25rem',
    textAlign: 'center',
    fontWeight: 'bold',
    marginBottom: 10,
  },

  profilePicContainer: {
    width: `calc(100% * 0.60)`,
    aspectRatio: '1 / 1',
    borderRadius: '50%',
    border: '2px solid #0002',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    overflow: 'hidden',
  },
  profilePic: {
    width: '100%',
  },
});

const IdBadge = withStyles(styles)(
  ({
    cardNumber,
    questionImage,
    questionLabel,
    questionLabel2,
    navLabel,
    confirmAnswer,
    classes,
    hideActions,
    selfInspectIntro,
    submitInspection,
    isSaving,
    pendingSaves,
    orderInfo,
    goBack,
    hideBackButton,
  }) => {
    const handleContinue = () => {
      confirmAnswer({
        cardNumber,
      });
    };

    return (
      <div className={classes.container}>
        {pendingSaves.some(ps => !ps.complete) && (
          <div className={classes.topHalf}>
            <CircularProgress style={{ color: '#2F89D9' }} />
            Saving response
          </div>
        )}

        <div className={classes.container}>
          <div className={classes.topHalf}>
            <img className={classes.image} src={jmiReportsImage} />
          </div>

          <div className={classes.bottomHalf}>
            <div
              className={classes.profilePicContainer}
              style={{
                marginTop: 24,
                backgroundImage: `url(${orderInfo?.remoteContactPhoto || imageNotAvailable})`,
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                backgroundSize: 'cover',
              }}
            >
              {/* <img className={classes.profilePic} src={orderInfo?.remoteContactPhoto || imageNotAvailable} /> */}
            </div>

            <section className={classes.reporterName} style={{ marginTop: 24 }}>
              {orderInfo?.remoteContactName || '-'}
            </section>

            <section className={classes.questionLabel} style={{ marginTop: 24 }}>
              JMI Reports
            </section>
            <section className={classes.questionValue}>
              <a href="tel:800-772-0436" style={{ color: '#000' }}>
                800-772-0436
              </a>
              {/* {orderInfo?.remoteContactPhone?.replace(/\D+/g, '').replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3') || '-'} */}
            </section>
          </div>
        </div>

        {!hideActions && !pendingSaves.some(ps => !ps.complete) && (
          <div className={classes.actionContainer}>
            {!hideBackButton && <SelfInspectBackButton onClick={goBack} className="flex-1 mr-20" />}

            <SelfInspectButton
              //
              label={navLabel}
              onClick={handleContinue}
              className="flex-1"
            />
          </div>
        )}
      </div>
    );
  },
);

IdBadge.propTypes = {};

IdBadge.defaultProps = {};

export default IdBadge;
